import React, { useState } from 'react'
import { Sparkles } from 'lucide-react'
import { Button, Chip } from 'components/ui'
import { useExecutionText } from '../../hooks/useExecutionText'
import { getAiScorePresentation } from 'components/TasksV2/model/aiScore'
export const AIAnalysisCard: React.FC<{
  loading?: boolean
  score?: number
  text?: string
  children?: React.ReactNode
}> = ({ loading, score, text, children }) => {
  const [expanded, setExpanded] = useState(false)
  const t = useExecutionText()
  const scorePresentation = getAiScorePresentation(loading ? undefined : score)

  return (
    <article
      className="execution-ai-card"
      aria-busy={loading}
      style={{ backgroundColor: scorePresentation.colors.bg, borderColor: scorePresentation.colors.border }}
    >
      <div className="execution-ai-title" style={{ color: scorePresentation.colors.text }}>
        <Sparkles size={18} />
        <strong>{loading ? t.aiLoading : t.ai}</strong>
        {!loading && scorePresentation.score !== undefined && (
          <Chip
            label={
              <>
                {t.score} <bdi>{scorePresentation.score}%</bdi>
              </>
            }
            size="sm"
            radius="7px"
            color={scorePresentation.colors.text}
            bg={scorePresentation.colors.bg}
            border="0"
          />
        )}
      </div>
      {loading ? (
        <>
          <div className="execution-shimmer" />
          <div className="execution-shimmer short" />
          <p className="execution-muted">{t.aiHint}</p>
        </>
      ) : (
        <>
          <div className={expanded ? '' : 'execution-ai-summary'}>
            {text}
            {children}
          </div>
          {text && text.length > 250 && (
            <Button
              variant="ghost"
              className="execution-link"
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
            >
              {expanded ? t.less : t.fullAnalysis}
            </Button>
          )}
        </>
      )}
    </article>
  )
}
